/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Paragraphs_0Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_5_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List your requirements in two groups: must-have and useful. A must-have is something whose failure prevents the task from being completed, such as running an existing macro or sending an editable file to a customer. A useful feature makes the task easier but has an acceptable alternative. This prevents an attractive interface or one missing convenience from dominating a more important requirement.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_5_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`把需求分为“必需”和“有帮助”两组。必需项是失败后就无法完成任务的能力，例如运行现有宏或向客户交付可编辑文件；有帮助的功能可以提高效率，但存在可接受的替代方法。这样可避免被漂亮界面或某个便利功能左右，而忽略关键要求。`)
};

/**
* | output |
* | --- |
* | "List your requirements in two groups: must-have and useful. A must-have is something whose failure prevents the task from being completed, such as running an..." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Paragraphs_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_5_paragraphs_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Paragraphs_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Paragraphs_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_5_paragraphs_0(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_5_paragraphs_0(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_5_paragraphs_0 as "gc.search_guides.gridcraft_vs_excel.sections.5.paragraphs.0" }